import { multiSelectorOptionsMapper, optionsMapper } from '../utils';

const options = ['5210', '5300', '6000'].map(o => ({
    value: o,
    label: o,
  }));

export const useBlockedProductStorageLocationOptions = () => {
  return {
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  };
};